import { render, staticRenderFns } from "./EconomyLeadOrdersPage.vue?vue&type=template&id=ae8e9432&"
import script from "./EconomyLeadOrdersPage.vue?vue&type=script&lang=js&"
export * from "./EconomyLeadOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports